<div
  (click)="imageClick(0)"
  class="innerBanner"
  [style.background-image]="
    travelInfoDataNew.bannerImage
      ? 'url(' + travelInfoDataNew.bannerImage + ')'
      : 'url(' + '../../../assets/images/NoImage.jpg' + ')'
  "
>
  <!-- inner banner-->
  <div class="bannerText"></div>
</div>

<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" />
  </ng-template>
</p-galleria>

<div class="container contentPanel">
  <app-breadcrumb></app-breadcrumb>
  <h1 class="text-center">{{ travelInfoDataNew.bannerTitle }}</h1>
  <div class="text-center banner-content" [innerHTML]="travelInfoDataNew.bannerContent"></div>
  <div class="gallery p-grid">
    <div *ngFor="let galleryItem of travelInfoDataNew.travelGallery" class="mp-0 p-col-12 p-md-4 p-lg-4">
      <div
        class="gallery-item"
        [style.background-image]="
          galleryItem.url ? 'url(' + galleryItem.url + ')' : 'url(' + '../../../assets/images/NoImage.jpg' + ')'
        "
        [style.background-repeat]="'no-repeat'"
        (click)="openGalleryItemPopup(galleryItem)"
      >
        <span class="gallery-item-title"
          ><strong>{{ galleryItem.gridTitle }}</strong></span
        >
      </div>
    </div>
  </div>
  <p class="text-center mt-4 banner-content2" [innerHTML]="travelInfoDataNew.bannerContent2"></p>
  <div class="gallery p-grid">
    <div *ngFor="let galleryItem of travelInfoDataNew.travelGallery2" class="mp-0 p-col-12 p-md-4 p-lg-4">
      <div
        class="gallery-item"
        [style.background-image]="
          galleryItem.url ? 'url(' + galleryItem.url + ')' : 'url(' + '../../../assets/images/NoImage.jpg' + ')'
        "
        [style.background-repeat]="'no-repeat'"
        (click)="openGalleryItemPopup(galleryItem)"
      >
        <span class="gallery-item-title"
          ><strong>{{ galleryItem.gridTitle }}</strong></span
        >
      </div>
    </div>
  </div>
  <p class="text-center alert-text mt-4" [innerHTML]="travelInfoDataNew.note"></p>
</div>

<p-dialog
  header="{{ selectedGalleryItem?.gridPopupTitle }}"
  [(visible)]="showGalleryItemPopup"
  styleClass="customDialog"
  [baseZIndex]="10000"
  [closable]="true"
  [modal]="true"
  (onHide)="closeGalleryItemPopup()"
>
  <!-- <h3 class="text-center popup-title">{{selectedGalleryItem?.gridPopupTitle}}</h3> -->
  <div class="popup-content" [innerHTML]="selectedGalleryItem?.gridPopupDescription"></div>
</p-dialog>
